// extracted by mini-css-extract-plugin
module.exports = {"page":"policy_page__pJZXB","card":"policy_card__X77tm","header":"policy_header__xwNrY","eyebrow":"policy_eyebrow__bEEvb","content":"policy_content__J_U0g"};